import { render } from "./dataStatistical.vue?vue&type=template&id=c2b5ca78&scoped=true"
import script from "./dataStatistical.vue?vue&type=script&lang=js"
export * from "./dataStatistical.vue?vue&type=script&lang=js"

import "./dataStatistical.vue?vue&type=style&index=0&id=c2b5ca78&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2b5ca78"]])

export default __exports__